/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Dirs_Delete_Dialog_Label_BulkInputs */

const es_settings_dirs_delete_dialog_label_bulk = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Label_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} carpetas`)
};

const en_settings_dirs_delete_dialog_label_bulk = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Label_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} directories`)
};

/**
* | output |
* | --- |
* | "{count} directories" |
*
* @param {Settings_Dirs_Delete_Dialog_Label_BulkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_delete_dialog_label_bulk = /** @type {((inputs: Settings_Dirs_Delete_Dialog_Label_BulkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Delete_Dialog_Label_BulkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_delete_dialog_label_bulk(inputs)
	return en_settings_dirs_delete_dialog_label_bulk(inputs)
});
export { settings_dirs_delete_dialog_label_bulk as "settings.dirs.delete_dialog.label_bulk" }